import { useEffect } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { useParams } from 'react-router-dom';
import { FormControlLabel, FormHelperText, MenuItem, Select } from '@mui/material';
import { useGetEmrsQuery, useGetWorkspaceFilesQuery } from '~/api/v2/hooks';
import { ButtonSpinner, SelectPlaceholder } from '~/components';

const WorkspaceFileField = () => {
  const projectId = +useParams().projectid!;
  const {
    control,
    watch,
    setValue,
    formState: { errors, touchedFields },
  } = useFormContext();
  const workspace = watch('notebook_id');
  const fieldValue = watch('file_name');

  const { data: emrData } = useGetEmrsQuery({ projectId });
  const { data: files, isFetching: isFilesLoading } = useGetWorkspaceFilesQuery(
    { projectId, emrId: emrData?.id || 0, workspaceId: workspace },
    {
      skip: !workspace || !emrData?.id || !projectId,
    },
  );

  useEffect(() => {
    if (!files || files?.includes(fieldValue) || !touchedFields.file_name) return;
    setValue('file_name', null, { shouldDirty: true, shouldValidate: true });
  }, [workspace]);

  return (
    <FormControlLabel
      label="CODE FILE"
      disabled={!workspace || isFilesLoading}
      required
      control={
        <Controller
          name="file_name"
          control={control}
          render={({ field }) => (
            <>
              <FormHelperText error={!!errors.file_name}>
                {(errors?.file_name?.message as string) || 'Select the code file for the job'}
              </FormHelperText>
              <Select
                {...field}
                value={field.value ?? ''}
                error={!!errors.file_name}
                startAdornment={isFilesLoading && <ButtonSpinner />}
                renderValue={() => {
                  if (!fieldValue) return <SelectPlaceholder>Select the code file</SelectPlaceholder>;

                  return fieldValue;
                }}
              >
                {files?.map((el) => (
                  <MenuItem value={el} key={el}>
                    {el}
                  </MenuItem>
                ))}
              </Select>
            </>
          )}
        />
      }
    />
  );
};

export default WorkspaceFileField;
